<div *ngIf="paymentDisabledMessage$ | async as paymentsDisabledMessage" class="top-message">
  {{paymentsDisabledMessage}}
</div>